import Icon from '../components/Icon.vue'

Icon.register({
  directions: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M502.6 233.3L278.7 9.4C266.2-3.1 245.8-3.1 233.3 9.4L9.4 233.3C-3.1 245.8-3.1 266.1 9.4 278.7L233.3 502.6C245.8 515.1 266.1 515.1 278.7 502.6L502.6 278.7C515.1 266.1 515.1 245.8 502.6 233.3zM401.6 245.9L317.4 323.6C312.3 328.3 304 324.7 304 317.7V264H208V328C208 332.4 204.4 336 200 336H168C163.6 336 160 332.4 160 328V248C160 230.3 174.3 216 192 216H304V162.3C304 155.3 312.3 151.7 317.4 156.4L401.6 234.1C405.1 237.3 405.1 242.7 401.6 245.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/directions.js
// module id = 2jic
// module chunks = 144